import { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles, useTheme } from "@mui/styles";
import { Box, Divider, useMediaQuery } from "@mui/material";
import Topbar from "./Topbar";
import Footer from "./Footer";
import Sidebar from "./Sidebar";

const sideBarWidth = 200;

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
}));

const Main = (props) => {
  const { children } = props;

  const theme = useTheme();
  const classes = useStyles(theme);
  const matches = useMediaQuery(theme.breakpoints.up("lg"));

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const open = openSidebar;

  return (
    <div
      className={clsx({
        [classes.root]: true,
      })}
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        {matches && (
          <Box
            sx={{
              minWidth: sideBarWidth,
            }}
          >
            <Sidebar variant="permanent" />
          </Box>
        )}
        <div
          className={clsx({
            [classes.root]: true,
          })}
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Topbar onSidebarOpen={handleSidebarOpen} />
          {!matches && (
            <Sidebar
              onClose={handleSidebarClose}
              open={open}
              variant="temporary"
            />
          )}
          <main>
            <Divider /> {children}
          </main>
        </div>
      </Box>
      <Footer />
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node,
};

export default Main;
